<template>
	<nk-wrapper v-if="context.ausstattung" spacing="md">
		<nk-accordion
			:title="context.titel || 'Ausstattung'"
			title-size="xl"
			:open="options.openAccordion || false"
		>
			<nk-row>
				<nk-col cols="shrink" class="hidden sm:block">
					<nk-icon
						icon="info"
						size="2xl"
						:inline="false"
						:background-color="true"
						color="neutral"
						variant="boxed"
					/>
				</nk-col>
				<nk-col cols="auto">
					<div class="nk-cms-content" v-html="context.ausstattung" />
				</nk-col>
			</nk-row>
		</nk-accordion>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {string} context.ausstattung
 */
export default {
	name: 'NkTemplateAusstattung',
	mixins: [TemplatesDefault],
};
</script>
